import { ACCESS_TOKEN, SHIRO_COOKIE, STORAGE } from '@/config';
import { LS, SS } from '@/util/StorageUtil';
import Cookies from 'js-cookie';

// 设置登录状态
function setUserToken() {
	const loginInfo = 'LGN_INFO_' + new Date().getTime();
	LS.set(STORAGE.LGN_STATUS.value, 'Y', true, 24 * 60 * 60); //一天
	SS.set(STORAGE.LGN_STATUS.value, 'Y');
	Cookies.set(STORAGE.LGN_STATUS.value, 'Y');
	LS.set(STORAGE.LGN_TAB_INFO.value, loginInfo, true, 24 * 60 * 60); //一天
	SS.set(STORAGE.LGN_TAB_INFO.value, loginInfo);
	Cookies.set(STORAGE.LGN_TAB_INFO.value, loginInfo);
}
// 清理登录状态
function clearUserToken() {
	LS.rm(STORAGE.LGN_STATUS.value);
	SS.rm(STORAGE.LGN_STATUS.value);
	Cookies.remove(STORAGE.LGN_STATUS.value);
	LS.rm(STORAGE.LGN_TAB_INFO.value);
	SS.rm(STORAGE.LGN_TAB_INFO.value);
	Cookies.remove(STORAGE.LGN_TAB_INFO.value);
	Cookies.remove(SHIRO_COOKIE);
	Cookies.remove(ACCESS_TOKEN);
	LS.rm(STORAGE.SESSION_INFO.value);
	SS.rm(STORAGE.SESSION_INFO.value);
	LS.rm(STORAGE.MENU_INFO.value);
	SS.rm(STORAGE.MENU_INFO.value);
	LS.rm('organ');
	SS.rm('organ');
}
//保存登录后的session数据
function setSessionData(data: any) {
	SS.set(STORAGE.SESSION_INFO.value, data);
}
//获取登录后的session数据
function getSessionData() {
	return JSON.parse(SS.get(STORAGE.SESSION_INFO.value) || '{}');
}
//保存登录后的session数据
function setTokenInfo(data: any) {
	SS.set(STORAGE.LGN_TOKEN_INFO.value, data);
}
//获取登录后的session数据
function getTokenInfo() {
	return SS.get(STORAGE.LGN_TOKEN_INFO.value);
}
function clearTokenInfo() {
	return SS.rm(STORAGE.LGN_TOKEN_INFO.value);
}
function setTime(menu: any) {
	SS.set(STORAGE.MENU_INFO.value, JSON.stringify(menu));
}
function getTime() {
	return SS.get(STORAGE.MENU_INFO.value);
}
// 清理菜单信息
function clearMenuInfo() {
	SS.rm(STORAGE.MENU_INFO.value);
}
function setOpenUrl(url: string) {
	SS.set(STORAGE.LGN_ACTIVE_URL.value, url);
}
function getOpenUrl() {
	return SS.get(STORAGE.LGN_ACTIVE_URL.value);
}
function clearOpenUrl() {
	SS.rm(STORAGE.LGN_ACTIVE_URL.value);
}
function clearRedux() {
	SS.rm(STORAGE.REDUX_INFO.value);
}

/**
 * 清理当次用户登录的所有存储信息
 * 1. 登录状态
 * 2. 菜单信息
 */
function clearUserInfo() {
	(window as any).hasMenus = false; //菜单已经处理状态变为false ，这样下次登录后才会重新刷新菜单信息
	// console.log('=======>>>退出登录菜单处理状态：', (window as any).hasMenus);
	clearUserToken();
	clearMenuInfo();
	clearTokenInfo();
	clearOpenUrl();
}

export {
	setUserToken,
	clearUserToken,
	setTime,
	getTime,
	clearMenuInfo,
	clearUserInfo,
	setSessionData,
	getSessionData,
	setTokenInfo,
	getTokenInfo,
	setOpenUrl,
	getOpenUrl,
	clearOpenUrl,
	clearRedux,
};
